import {
  FETCH_SHIFTS, FETCH_SHIFTS_SUCCESS, FETCH_SHIFTS_FAILURE,
  CREATE_SHIFT, CREATE_SHIFT_SUCCESS, CREATE_SHIFT_FAILURE,
  UPDATE_SHIFT, UPDATE_SHIFT_SUCCESS, UPDATE_SHIFT_FAILURE,
  DELETE_SHIFT, DELETE_SHIFT_SUCCESS, DELETE_SHIFT_FAILURE
} from "./actionTypes";

const initialState = {
  shifts: [],
  loading: false,
  success:false,
  error: null,
};

const shiftReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_SHIFTS:
      return { ...state, loading: true,success:false };
    case FETCH_SHIFTS_SUCCESS:
      return { ...state, loading: false, shifts: action.payload.data,success:false };
    case FETCH_SHIFTS_FAILURE:
      return { ...state, loading: false, error: action.payload,success:false };

    case CREATE_SHIFT:
      return { ...state, loading: true,success:false };
    case CREATE_SHIFT_SUCCESS:
      return {
        ...state, loading: false, success:true, shift: action.payload, error: null };
    case CREATE_SHIFT_FAILURE:
      return { ...state, loading: false, success:false, error: action.payload };

      case DELETE_SHIFT:
           return { ...state, loading: true,success:false };
    case DELETE_SHIFT_SUCCESS:
      return {
        ...state, loading: false, success:true, shift: action.payload, error: null };
    case DELETE_SHIFT_FAILURE:
      return { ...state, loading: false, error: action.payload,success:false };

    default:
      return state;
  }
};

export default shiftReducer;
